import { getAccumulatedReportList } from "@/helpers/service/api/accumulated";
import { json2csv_fn, toThousands } from "@/utils/common";
import locale from "@/helpers/locale";
import moment from 'moment';
import { getExportName_fn } from '@/utils/common'
import { weekLocaleArray } from "@/utils/common";


export function exportCSV_fn(requestParma) {
  getAccumulatedReportList(requestParma).then(res => {
    if (res.data.filmRecords.length > 0) {
      let csvData = [];
      const fields = [
        {
          label: locale("global.titleOfWork"),
          value: "name",
        },
        {
          label: locale("global.versions"),
          value: "version",
        },
        {
          label: locale("report.saleWeekly.publicWeek"),
          value: "week",
        },
        {
          label: locale("movie.distribution"),
          value: "clientName",
        },
        {
          label: locale("report.saleWeekly.dayTotal") + locale("cashierReport.dialog.th.cashQty"),
          value: "dayTotalQty",
        },
        {
          label: locale("report.saleWeekly.dayTotal") + locale("cashierReport.dialog.th.amount"),
          value: "dayTotalAmount",
        },
        {
          label: locale("report.saleWeekly.weekTotal") + locale("cashierReport.dialog.th.cashQty"),
          value: "weekTotalQty",
        },
        {
          label: locale("report.saleWeekly.weekTotal") + locale("cashierReport.dialog.th.amount"),
          value: "weekTotalAmount",
        },
        {
          label: locale("report.saleWeekly.monthTotal") + locale("cashierReport.dialog.th.cashQty"),
          value: "monthTotalQty",
        },
        {
          label: locale("report.saleWeekly.monthTotal") + locale("cashierReport.dialog.th.amount"),
          value: "monthTotalAmount",
        },
        {
          label: locale("report.accumulated.total") + locale("cashierReport.dialog.th.cashQty"),
          value: "accumulatedQty",
        },
        {
          label: locale("report.saleWeekly.dayTotal") + locale("cashierReport.dialog.th.amount"),
          value: "accumulatedAmount",
        }
      ];
      res.data.filmRecords.forEach(item => {
        item.versionRecords.forEach(record => {
          csvData.push({
            name: item.filmName,
            version: record.version,
            week: record.week,
            clientName: record.clientName,
            dayTotalQty: record.daily.qty,
            dayTotalAmount: record.daily.amount,
            weekTotalQty: record.weekly.qty,
            weekTotalAmount: record.weekly.amount,
            monthTotalQty: record.monthly.qty,
            monthTotalAmount: record.monthly.amount,
            accumulatedQty: record.accumulated.qty,
            accumulatedAmount: record.accumulated.amount,
          });
        });
        csvData.push({
          type: "subTotal",
          name: item.filmName,
          version: locale("reprot.accumulated.totalMovie"),
          week: "",
          clientName: "",
          dayTotalQty: item.versionRecords.reduce((total, item) => total + item.daily.qty, 0),
          dayTotalAmount: item.versionRecords.reduce((total, item) => total + item.daily.amount, 0),
          weekTotalQty: item.versionRecords.reduce((total, item) => total + item.weekly.qty, 0),
          weekTotalAmount: item.versionRecords.reduce((total, item) => total + item.weekly.amount, 0),
          monthTotalQty: item.versionRecords.reduce((total, item) => total + item.monthly.qty, 0),
          monthTotalAmount: item.versionRecords.reduce((total, item) => total + item.monthly.amount, 0),
          accumulatedQty: item.versionRecords.reduce((total, item) => total + item.accumulated.qty, 0),
          accumulatedAmount: item.versionRecords.reduce((total, item) => total + item.accumulated.amount, 0),
        });
      });

      csvData.push({
        name: locale("report.ticketSales.allTotal"),
        version: "",
        week: "",
        clientName: "",
        dayTotalQty: csvData.filter(item => item.type === "subTotal").reduce((total, record) => total + record.dayTotalQty, 0),
        dayTotalAmount: csvData.filter(item => item.type === "subTotal").reduce((total, record) => total + record.dayTotalAmount, 0),
        weekTotalQty: csvData.filter(item => item.type === "subTotal").reduce((total, record) => total + record.weekTotalQty, 0),
        weekTotalAmount: csvData.filter(item => item.type === "subTotal").reduce((total, record) => total + record.weekTotalAmount, 0),
        monthTotalQty: csvData.filter(item => item.type === "subTotal").reduce((total, record) => total + record.monthTotalQty, 0),
        monthTotalAmount:csvData.filter(item => item.type === "subTotal").reduce((total, record) => total + record.monthTotalAmount, 0),
        accumulatedQty: csvData.filter(item => item.type === "subTotal").reduce((total, record) => total + record.accumulatedQty, 0),
        accumulatedAmount: csvData.filter(item => item.type === "subTotal").reduce((total, record) => total + record.accumulatedAmount, 0),
      });
      // csvData.forEach(item => {
      //   item.dayTotalQty = "¥" + toThousands(item.dayTotalQty);
      //   item.dayTotalAmount = "¥" + toThousands(item.dayTotalAmount);
      //   item.weekTotalQty = "¥" + toThousands(item.weekTotalQty);
      //   item.weekTotalAmount = "¥" + toThousands(item.weekTotalAmount);
      //   item.monthTotalQty = "¥" + toThousands(item.monthTotalQty);
      //   item.monthTotalAmount = "¥" + toThousands(item.monthTotalAmount);
      //   item.accumulatedQty = "¥" + toThousands(item.accumulatedQty);
      //   item.accumulatedAmount = "¥" + toThousands(item.accumulatedAmount);
      // });
      const {reportDate } = requestParma
      json2csv_fn(csvData, fields, 
      // moment().format("YYYYMMDDHHmm") + "_" + locale("sideMenu.reports.accumulated")
      getExportName_fn(
        locale("sideMenu.reports.accumulated"),
        '',
        '',
        '',
        reportDate,
        res.data.cinemaName,
        moment().format('YYYYMMDDHHmm')
      )
      );
    }
  });
}